import React from "react";
import { Tooltip } from "antd";
import { AiOutlineExclamation } from "react-icons/ai";
import { returnEuroString } from "../../helpers/Utils";

const ImumOldPricePreview = ({ value }) => {
  return (
    <div className="d-flex align-items-center justify-content-center">
      {value?.price_updated_at && (
        <Tooltip
          zIndex={999999}
          placement="top"
          title={`Last time price changed ${value.price_updated_at} from the cost`}
        >
          <div
            className="rounded-circle d-flex align-items-center justify-content-center mr-1"
            style={{
              backgroundColor: "#5F5F5F",
              width: 12,
              height: 12,
            }}
          >
            <AiOutlineExclamation size={7} color="#fff" />
          </div>
        </Tooltip>
      )}
      <nobr>{value.old_price ? returnEuroString(value.old_price) : "-"}</nobr>
      {value.updated_at && (
        <Tooltip
          zIndex={999999}
          placement="top"
          title={`Last time price changed ${value.updated_at}`}
        >
          <div
            className="rounded-circle d-flex align-items-center justify-content-center ml-1"
            style={{
              backgroundColor: "#5F5F5F",
              width: 12,
              height: 12,
            }}
          >
            <AiOutlineExclamation size={7} color="#fff" />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default ImumOldPricePreview;
